import React from 'react';
import PropTypes from 'prop-types';
import { HashRouter } from 'react-router-dom';
import AppWrapper from './RouterWrapper/AppWrapper';

export default function RouterWrapper({ children, alwaysRender }) {
  return (
    <HashRouter>
      <AppWrapper alwaysRender={alwaysRender}>
        {children}
      </AppWrapper>
    </HashRouter>
  );
}

RouterWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  alwaysRender: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

RouterWrapper.defaultProps = {
  children: [],
  alwaysRender: [],
};
